import GradientBackgroundMaterial from '../materials/GradientBackgroundMaterial';
import { DEFAULT_BG_GRADIENT } from '../../../constants/colors';
import { formatGradient } from '../utils/gradient';
import { SIZES_COMMON } from '../../../constants/sizes';
import THREE from '../utils/threeClassesAdapter';

class GradientBackground extends THREE.Mesh {
    #material;

    constructor() {
        const geometry = new THREE.PlaneBufferGeometry(100, 100);

        const params = {
            ...formatGradient(DEFAULT_BG_GRADIENT),
            aspect: SIZES_COMMON.bgSceneAspectRatio
        };
        const material = new GradientBackgroundMaterial(params);

        super(geometry, material);

        this.params = params;
        this.#material = material;
    }

    set resolution(value) {
        this.#material.resolution = value;
    }

    get resolution() {
        return this.#material.resolution;
    }

    set progress(value) {
        this.#material.progress = value;
    }

    get progress() {
        return this.#material.progress;
    }
}

export default GradientBackground;
